
  <div>
    <router-view />
    <p>This is a default layout</p>
  </div>
